import React from 'react'
import { format, getMonth } from 'date-fns'
import styled from 'styled-components'
import colors from 'variables/colors'
import DPTopNavItems from 'nav/top/dataProviders/DPTopNavItems'
import event from '@covenant-presbyterian/registration/event'
import NavList from '../../components/Nav/NavList'
import NavItem from '../../components/Nav/NavItem'

const Container = styled.div`
  left: 0px;
  right: 0px;
  width: 100%;
  background: ${colors.content.background.normal};
  color: ${colors.primary};
  z-index: 99;
`

const LeftList = styled(NavList)`
  padding-left: '15px', @media (max-width: 999px) {
    padding-left: 5px;
  }
`

const GANavItem = styled(({ className, ...other }) => (
  <NavItem linkClassName={className} {...other} />
))`
  && {
    color: ${colors.primary};
    height: 41px;
  }
`

export default () => {
  const { dateRange: [startDate, endDate] = [], locationName } = event || {}
  const friendlyDateStr =
    getMonth(startDate) === getMonth(endDate)
      ? `${format(startDate, 'MMM D')}-${format(endDate, 'D, YYYY')}`
      : `${format(startDate, 'MMM D')} - ${format(endDate, 'MMM D, YYYY')}`

  return (
    <>
      <Container key="ga-nav-bar">
        <DPTopNavItems localUrlPrefix="ga">
          {items => (
            <LeftList
              ItemComponent={GANavItem}
              size="none"
              items={[
                { label: <b>General Assembly</b>, href: '/ga' },
                ...items,
                {
                  label: `${friendlyDateStr} - ${locationName}`,
                  style: { float: 'right' },
                },
              ]}
            />
          )}
        </DPTopNavItems>
      </Container>
      <div key="ga-nav-bar-displacement" />
    </>
  )
}
